import { ISquawk } from "src/interfaces";

export const hasAircraftSquawks = (aircraftSquawks?: Array<ISquawk>) =>
  (aircraftSquawks ?? []).some((s) => s.grounded && !s.resolved);
